<template>
    <main-content>
        <kt-panel>
            <kt-panel-body v-if="recharge_wallet_result_status == 'success'">
                <div>
                    <kt-row lg="12" md="12" sm="12" :class="'alert '+varient()">
                        <kt-col lg="6" md="6" sm="6">
                            <li>
                                {{ recharge_wallet_result_data.message }}
                            </li>
                        </kt-col>
                    </kt-row>
                </div>
            </kt-panel-body>
            <loader v-else></loader>
        </kt-panel>
    </main-content>
</template>

<script>
import {mapGetters} from "vuex";
import mainContent from '@/components/main-content'
import Loading from '@/components/custom/loading'

export default {
    name: "CheckoutCardToCardRechargeWalletResult",

    components: {
        'main-content': mainContent,
        'loader': Loading
    },
    computed: {
        ...mapGetters('cardToCard', [
            'recharge_wallet_result_data',
            'recharge_wallet_result_status'
        ]),
    },

    data() {
        return {
            tracking_code: this.$route.params.tracking_code
        }
    },
    methods: {
        varient() {
            if (this.recharge_wallet_result_data.payment_succeed === true)
                return 'alert-success'
            else
                return 'alert-danger'
        }
    },
    mounted() {
        this.$store.dispatch('cardToCard/rechargeWalletData', this.tracking_code)
    },
}
</script>

<style scoped>
.success {
    color: #00bea5;
}
.danger {
    color: red;
}
</style>